import { useCallback } from 'react';
import type { RazorpayCheckoutActionOptions } from '../../../../../auth/hooks/razorpay/types';
import { useRazorpay } from '../../../../../auth/hooks/razorpay/useRazorpay';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { RazorpayControlAction } from './schema/controlRazorpay';

interface ControlRazorpayCheckoutPayload {
  order_id?: string;
  amount?: number | string;
  currency?: string;
}

function useControlRazorpay() {
  const { checkout } = useRazorpay();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onControlRazorpay: OnActionType = useCallback(
    async (args) => {
      const { action, actionContext } = args;
      const operation = action.payload?.operation;

      switch (operation) {
        case RazorpayControlAction.Checkout: {
          const payload = (action.payload ?? {}) as Record<string, unknown>;
          const computedPayload = getNoCodeComputedData<ControlRazorpayCheckoutPayload>(
            payload,
            (actionContext ?? {}) as Record<string, unknown>,
          );

          const amount = computedPayload.amount;
          const checkoutOptions: RazorpayCheckoutActionOptions = {
            order_id: computedPayload.order_id,
            amount: typeof amount === 'string' ? Number(amount) : amount,
            currency: computedPayload.currency,
          };
          await checkout(checkoutOptions);
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
        }
        default:
          return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
    },
    [checkout, getNoCodeComputedData],
  );

  return { onControlRazorpay };
}

export default useControlRazorpay;
